import React from "react";
import Slider from "react-slick";
import useWindowSize from "../../hooks/useWindowSize";

// const recognitionDesktop = [
//     "https://img.learntube.ai/public-assets/Onboarding_Revamp/Group%208182.png?updatedAt=1694583914135",
//     "https://img.learntube.ai/public-assets/Onboarding_Revamp/Group%206958.png?updatedAt=1694584148121",
//     "https://img.learntube.ai/public-assets/Onboarding_Revamp/Group%206957.svg?updatedAt=1694584149737",
//     "https://img.learntube.ai/public-assets/Onboarding_Revamp/Group%206956.svg?updatedAt=1694584149415",
// ]
const recognitionDesktop = [
  "https://img.learntube.ai/public-assets/Onboarding_Revamp/Group%208182%20(1).png?updatedAt=1694776801051",
  "https://img.learntube.ai/public-assets/Onboarding_Revamp/Group%206958.png?updatedAt=1694584148121",
  "https://img.learntube.ai/public-assets/Onboarding_Revamp/Group%206957.svg?updatedAt=1694584149737",
  "https://img.learntube.ai/public-assets/Onboarding_Revamp/Group%206956.svg?updatedAt=1694584149415",
];

const RecognitionSection = () => {
  const { width } = useWindowSize();

  const workAtsettings = {
    dots: false,
    slidesToShow: 3,
    rows: 1,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 3000,
    easing: "linear",
    cssEase: "linear",
    infinite: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        },
      },

      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3.5,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: width <= 360 ? 3.1 : 3.3,
          infinite: true,
          dots: false,
          arrows: false,
          swipeToSlide: false,
        },
      },
    ],
  };
  return (
    <div className="w-full">
      <div className="md:hidden">
        <div className="w-full">
          <img
            src={recognitionDesktop[0]}
            alt="review image"
            className="h-auto w-full"
          />
        </div>
        <div className="mt-3 flex justify-center">
          <div className="mr-2 h-[125px] max-w-[100px]">
            <img
              src={recognitionDesktop[1]}
              alt="review image"
              className="h-full w-full object-fill"
            />
          </div>
          <div className="mr-2 h-[120px] max-w-[100px]">
            <img
              src={recognitionDesktop[2]}
              alt="review image"
              className="h-full w-full rounded-xl object-cover"
            />
          </div>
          <div className="ml-0.5 h-[120px] max-w-[100px]">
            <img
              src={recognitionDesktop[3]}
              alt="review image"
              className="h-full w-full rounded-xl object-cover"
            />
          </div>
        </div>
      </div>
      <div className="hidden md:flex">
        <div className="flex h-[145px] w-1/2 items-center rounded-xl bg-[#2D4F71]">
          <img src={recognitionDesktop[0]} alt="review image" />
        </div>
        <div className="ml-1 flex w-1/2 justify-between">
          <div className="ml-1 h-[150px] w-1/3">
            <img
              src={recognitionDesktop[1]}
              alt="review image"
              className="h-full w-full object-fill"
            />
          </div>
          <div className="-ml-1 h-[145px] w-[30%]">
            <img
              src={recognitionDesktop[2]}
              alt="review image"
              className="h-full w-full rounded-xl object-cover"
            />
          </div>
          <div className="h-[145px] w-[30%]">
            <img
              src={recognitionDesktop[3]}
              alt="review image"
              className="h-full w-full rounded-xl object-cover"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecognitionSection;
